import React from 'react';
import { Link } from 'react-router-dom';

function CardItem(props) {
  return (
    <>
      <li className='cards__item'>
          <div className='cards__item__info'>
            <h5 className='cards__item__text'>{props.text}</h5>
            
            <h5 className='cards__item__label'>{props.label}</h5>
            
            <h5 className='cards__item__labela'>{props.labela}</h5>
            <h5 className='cards__item__labelb'>{props.labelb}</h5>
            <h5 className='cards__item__labelc'>{props.labelc}</h5>

            <h5 className='cards__item__label1'>{props.label1}</h5>
            
            <h5 className='cards__item__labeld'>{props.labeld}</h5>
            <h5 className='cards__item__labele'>{props.labele}</h5>
            <h5 className='cards__item__labelf'>{props.labelf}</h5>
            <h5 className='cards__item__labelg'>{props.labelg}</h5>

            <h5 className='cards__item__label2'>{props.label2}</h5>
            
            <h5 className='cards__item__labelh'>{props.labeld}</h5>

            <h5 className='cards__item__label3'>{props.label3}</h5>
            
            <h5 className='cards__item__labeli'>{props.labeli}</h5>
            <h5 className='cards__item__labelj'>{props.labelj}</h5>
            <h5 className='cards__item__labelk'>{props.labelk}</h5>

            <h5 className='cards__item__label4'>{props.label4}</h5>
            

          </div>
        
      </li>
    </>
  );
}

export default CardItem;